import React from 'react'

export const michiganSetupVars = {
  siteId: 'michigan',
  pathPrefix: '/mi',
  menuHeader: "Discover Michigan's Solution for:",
  appUrl: 'https://mi.headed2.com',
  logoImg: '/images/assets/michigan/horizontal/dark.svg',
  headerTitle: `The Michigan CareerExplorer is a system designed for Michigan`
}
